import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

// Routes
import { useUserData } from "../../../context/UserDataContext";
import { CustomerBasketProvider } from "../../../context/CustomerBasketContext";

// Setting
import Ring from "../setting/ring/Ring";
import Brand from "../setting/brand/Brand.js";
import Customer from "../setting/customer/Customer";
import Producer from "../setting/producer/Producer";
import Stock from "../setting/stock/Stock.js";
import City from "../setting/city/City";
import Employee from "../setting/employee/Employee";
import Parameterrr from "../setting/parameter/Parameter";

// Customer
import CustomerCreateOrder from "../customers/create-order/CustomerCreateOrder";
import CustomerNewOrders from "../customers/new-orders/CustomerNewOrders.js";
import CustomerCurrentOrders from "../customers/current-order/CustomerCurrentOrders";
import CustomerDeliveredOrders from "../customers/recevied-order/CustomerDeliveredOrders.js";
import CustomerRemovedOrders from "../customers/remove-order/CustomerRemovedOrders.js";

// Producer
import ProducerCreateOrder from "../producers/create-order/ProducerCreateOrder.js";
import ProducerCreateOrderNew from "../producers/create-order-new/ProducerCreateOrderNew";
import { ProducerBasketProvider } from "../../../context/ProducerBasketContext";
import ProviderWaitingOrders from "../producers/waiting-order/ProviderWaitingOrders.js";
import ProviderCurrentOrders from "../producers/current-order/ProviderCurrentOrders.js";
import AdminProviderCompleteOrder from "../producers/complete-order/AdminProviderCompleteOrder.js";

// Reports
import AdminReportsInventory from "../reports/Inventory/AdminReportsInventory.js";
import AdminReportsBangleInfo from "../reports/bangle-information/AdminReportsBangleInfo.js";
import AdminReportsAcceptOrder from "../reports/accept-order-admin/AdminReportsAcceptOrder.js";
import AdminReportsReqInvReg from "../reports/request-Inventory-register/AdminReportsReqInvReg.js";
import AdminReportOrderStock from "../reports/order-stock/AdminReportOrderStock.js";
import AdminReportsPrintInventory from "../reports/Inventory/AdminReportsPrintInventory.js";
import AdminReportsPrintBangleInfo from "../reports/bangle-information/AdminReportsPrintBangleInfo";
import AdminReportsPrintReqInvReg from "../reports/request-Inventory-register/AdminReportsPrintReqInvReg";
import AdminPrintReportsAcceptOrder from "../reports/accept-order-admin/AdminPrintReportsAcceptOrder";
import AdminReportPrintOrderStock from "../reports/order-stock/AdminReportPrintOrderStock";
import AdminReportBangleOnprogressCustomer from "../reports/bangle-onprogress-customer/AdminReportBangleOnprogressCustomer";
import AdminPrintReportBangleOnprogressCustomer from "../reports/bangle-onprogress-customer/AdminPrintReportBangleOnprogressCustomer";

// Quick Access
import ChangeCustomer from "../quick-access/ChangeCustomer";
import AdminChangeOrderState from "../quick-access/AdminChangeOrderState";
import EditOrder from "../quick-access/EditOrder";
import AdminCancelOrder from "../quick-access/AdminCancelOrder";
import AdminRemoveOrder from "../quick-access/AdminRemoveOrder";
import OrderLogs from "../quick-access/OrderLogs";

// Chats
import AdminMessages from "../messages/AdminMessages";
import Chats from "../chats/Chats";
import TableRing from "../setting/table-ring/TableRing";
import AdminPrintOrderDetails from "../customers/current-order/AdminPrintOrderDetails";
import AdminPrintOrderDetailsByBangle from "../customers/current-order/AdminPrintOrderDetailsByBangle";
import AdminPrintGeneralOrderByCustomer from "../customers/current-order/AdminPrintGeneralOrderByCustomer";
import AdminPrintGeneralOrderByBangle from "../customers/current-order/AdminPrintGeneralOrderByBangle";
import AdminReturnedOrderList from "../return/AdminReturnedOrderList";
import AdminGetProviderBangle from "../reports/admin-get-provider-bangle/AdminGetProviderBangle";
import AdminPrintCompleteOrder from "../customers/recevied-order/AdminPrintCompleteOrder";
import AdminReportsSoldBangle from "../reports/sold-bangle/AdminReportsSoldBangle";
import AdminReportsPringSoldBangle from "../reports/sold-bangle/AdminReportsPringSoldBangle";
import AdminGetProviderPrintBangle from "../reports/admin-get-provider-bangle/AdminGetProviderPrintBangle";
import AdminPrintCustomerNewOrder from "../customers/new-orders/AdminPrintCustomerNewOrder";
import AdminPrintProviderNewOrder from "../producers/waiting-order/AdminPrintProviderNewOrder";
import AdminNewOrderPrintOrderDetails from "../customers/new-orders/AdminNewOrderPrintOrderDetails";
import AdminNewProviderOrderPrintOrderDetails from "../producers/waiting-order/AdminNewOrderPrintOrderDetails";
import AdminCurrentProviderOrderPrintOrderDetails from "../producers/current-order/AdminCurrentProviderOrderPrintOrderDetails";
import AdminReveviedOrderPrintOrderDetails from "../customers/recevied-order/AdminReveviedOrderPrintOrderDetails";
import AdminPrintRemoveOrder from "../customers/remove-order/AdminPrintRemoveOrder";
import AdminRemoveOrderPrintOrderDetails from "../customers/remove-order/AdminRemoveOrderPrintOrderDetails";
import CustomerDeliverdOrdersTab from "../customers/recevied-order/CustomerDeliverdOrdersTab";
import AdminPrintCompleteGeneralOrderByBangle from "../customers/recevied-order/AdminPrintCompleteGeneralOrderByBangle";
import AdminPrintProviderCurrentOrder from "../producers/current-order/AdminPrintProviderCurrentOrder";
import AdminPrintProviderCompleteOrder from "../producers/complete-order/AdminPrintProviderCompleteOrder";
import AdminCompleteOrderPrintOrderDetails from "../producers/complete-order/AdminCompleteOrderPrintOrderDetails";
import ProviderStock from "../setting/provider-stock/ProviderStock";
import StockTable from "../setting/stock/StockTable";
import AdminProviderNeedConfirmedOrder from "../producers/need-confirmed-order/AdminProviderNeedConfirmedOrder.js";
import AdminPrintProviderNeedConfirmedOrder from "../producers/need-confirmed-order/AdminPrintProviderNeedConfirmedOrder";
import AdminNeedConfirmedOrderPrintOrderDetails from "../producers/need-confirmed-order/AdminNeedConfirmedOrderPrintOrderDetails";

const AdminRoutes = () => {
  const { userData } = useUserData();

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/customers-new-orders" />} />

        {/*..................Setting................... */}
        <Route path="/setting-ring" element={<Ring />} />
        <Route path="//setting-table-ring" element={<TableRing />} />
        <Route path="/setting-brand" element={<Brand />} />
        <Route path="/setting-customer" element={<Customer />} />
        <Route path="/setting-employee" element={<Employee />} />
        <Route path="/setting-producer" element={<Producer />} />
        <Route path="/setting-stock" element={<Stock />} />
        <Route path="/setting-stock-table" element={<StockTable />} />
        <Route path="/setting-provider-stock" element={<ProviderStock />} />
        <Route path="/setting-city" element={<City />} />
        <Route path="/setting-set-parameter" element={<Parameterrr />} />

        {/*..................Customer................... */}
        <Route
          path="/create-order-customer"
          element={
            <CustomerBasketProvider>
              <CustomerCreateOrder />
            </CustomerBasketProvider>
          }
        />
        <Route path="/customers-new-orders" element={<CustomerNewOrders />} />
        <Route
          path="/customers-current-orders"
          element={<CustomerCurrentOrders />}
        />
        <Route
          path="/print-customers-new-orders/:unique_id/:store_name/:date"
          element={<AdminPrintCustomerNewOrder />}
        />
        <Route
          path="/print-providers-new-orders/:unique_id/:store_name/:date"
          element={<AdminPrintProviderNewOrder />}
        />

        <Route
          path="/print-providers-current-orders/:unique_id/:store_name/:date"
          element={<AdminPrintProviderCurrentOrder />}
        />
        <Route
          path="/print-providers-complete-orders/:unique_id/:store_name/:date"
          element={<AdminPrintProviderCompleteOrder />}
        />
        <Route
          path="/print-providers-need-confirmed-orders/:unique_id/:store_name/:date"
          element={<AdminPrintProviderNeedConfirmedOrder />}
        />
        <Route
          path="/print-customers-current-orders-by-customer/:unique_id/:store_name/:date/:city"
          element={<AdminPrintGeneralOrderByCustomer />}
        />
        <Route
          path="/print-customers-complete-orders-by-customer/:unique_id/:store_name/:date/"
          element={<AdminPrintCompleteOrder />}
        />

        <Route
          path="/print-customers-removed-orders/:unique_id/:customer_name/:date/"
          element={<AdminPrintRemoveOrder />}
        />

        <Route
          path="/print-customers-current-orders-by-bangle/:unique_id/:bangle_name/:brand/:status/:zero_status"
          element={<AdminPrintGeneralOrderByBangle />}
        />
        <Route
          path="/print-customers-complete-orders-by-bangle/:unique_id/:bangle_name/:brand/:status/:zero_status"
          element={<AdminPrintCompleteGeneralOrderByBangle />}
        />
        <Route
          path="/customers-deliverd-orders"
          element={<CustomerDeliverdOrdersTab />}
        />
        <Route
          path="/customers-cancelled-orders"
          element={<CustomerRemovedOrders />}
        />

        {/*..................Return................... */}

        {/* <Route path="/returned-order" element={<ReturnedOrder />} /> */}
        <Route
          path="/returned-order-list"
          element={<AdminReturnedOrderList />}
        />

        {/*..................Producer................... */}
        <Route
          path="/create-order-producer"
          element={
            <ProducerBasketProvider>
              <ProducerCreateOrderNew />
            </ProducerBasketProvider>
          }
        />
        <Route
          path="/provider-waiting-orders"
          element={<ProviderWaitingOrders />}
        />
        <Route
          path="/provider-current-orders"
          element={<ProviderCurrentOrders />}
        />
        <Route
          path="/provider-received-orders"
          element={<AdminProviderCompleteOrder />}
        />
        <Route
          path="/provider-need-confirmed-orders"
          element={<AdminProviderNeedConfirmedOrder />}
        />
        {/*..................Report................... */}
        <Route path="/report-inventory" element={<AdminReportsInventory />} />
        <Route
          path="/report-bangles-informations"
          element={<AdminReportsBangleInfo />}
        />
        <Route
          path="/report-request-inventory-register"
          element={<AdminReportsReqInvReg />}
        />
        <Route
          path="/report-provider-bangle"
          element={<AdminGetProviderBangle />}
        />
        <Route
          path="/print-report-provider-bangle/:provider"
          element={<AdminGetProviderPrintBangle />}
        />
        <Route
          path="/report-accept-order-admin"
          element={<AdminReportsAcceptOrder />}
        />
        <Route path="/report-order-stock" element={<AdminReportOrderStock />} />
        <Route
          path="/report-bangle-onprogress-customer"
          element={<AdminReportBangleOnprogressCustomer />}
        />
        <Route
          path="/report-bangle-sold"
          element={<AdminReportsSoldBangle />}
        />
        <Route
          path="/print-report-inventory"
          element={<AdminReportsPrintInventory />}
        />
        <Route
          path="/print-report-bangle-info"
          element={<AdminReportsPrintBangleInfo />}
        />
        <Route
          path="/print-report-bangle-sold-info/:code/"
          element={<AdminReportsPringSoldBangle />}
        />
        <Route
          path="/print-report-request-inventory-register"
          element={<AdminReportsPrintReqInvReg />}
        />
        <Route
          path="/print-report-accept-order-admin"
          element={<AdminPrintReportsAcceptOrder />}
        />
        <Route
          path="/print-report-order-stock"
          element={<AdminReportPrintOrderStock />}
        />

        <Route
          path="/print-report-bangle-onprogress-customer/:bangle"
          element={<AdminPrintReportBangleOnprogressCustomer />}
        />

        <Route
          path="/print-report-details/:id"
          element={<AdminPrintOrderDetails />}
        />

        <Route
          path="/print-new-order-report-details/:id"
          element={<AdminNewOrderPrintOrderDetails />}
        />
        <Route
          path="/print-new-provider-order-report-details/:id"
          element={<AdminNewProviderOrderPrintOrderDetails />}
        />
        <Route
          path="/print-complete-provider-order-report-details/:id"
          element={<AdminCompleteOrderPrintOrderDetails />}
        />
        <Route
          path="/print-need-confirmed-provider-order-report-details/:id"
          element={<AdminNeedConfirmedOrderPrintOrderDetails />}
        />
        <Route
          path="/print-current-provider-order-report-details/:id"
          element={<AdminCurrentProviderOrderPrintOrderDetails />}
        />

        <Route
          path="/print-recevied-report-details/:id"
          element={<AdminReveviedOrderPrintOrderDetails />}
        />

        <Route
          path="/print-removed-report-details/:id"
          element={<AdminRemoveOrderPrintOrderDetails />}
        />

        <Route
          path="/print-report-details-by-bangle/:id"
          element={<AdminPrintOrderDetailsByBangle />}
        />

        {/*..................Quick Access................... */}
        <Route
          path="/quick-access-change-customer"
          element={<ChangeCustomer />}
        />
        <Route path="/quick-access-edit-order" element={<EditOrder />} />
        <Route
          path="/quick-access-order-state-change"
          element={<AdminChangeOrderState />}
        />
        <Route
          path="/quick-access-delete-order"
          element={<AdminCancelOrder />}
        />
        <Route
          path="/quick-access-remove-order"
          element={<AdminRemoveOrder />}
        />
        <Route path="/quick-access-log-order" element={<OrderLogs />} />

        {/*..................Messages................... */}
        <Route path="/send_messages" element={<AdminMessages />} />
        {/*..................Chats................... */}
        <Route path="/chats" element={<Chats />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default AdminRoutes;
